import React from 'react';
import { Maximize2, Package, Percent, Trash2 } from 'lucide-react';

const BoardMetricsCard = ({ board, positions = [] }) => {
  const totalArea = parseFloat(board.total_area) || 0;
  const usedArea = parseFloat(board.used_area) || 0;
  const wasteArea = totalArea - usedArea;
  const efficiency = totalArea > 0 ? ((usedArea / totalArea) * 100).toFixed(1) : '0.0';

  const totalParts = positions.length;
  const pendingCuts = positions.filter(p => p.cut_status === 'PENDING').length;
  const completedCuts = positions.filter(p => p.cut_status === 'COMPLETED').length;

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Métricas da Chapa</h3>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-50 text-blue-600 rounded-lg">
            <Maximize2 className="w-4 h-4" />
          </div>
          <div>
            <p className="text-xl font-bold text-gray-900">{totalArea.toFixed(3)} m²</p>
            <p className="text-xs text-gray-500">Área Total</p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <div className="p-2 bg-emerald-50 text-emerald-600 rounded-lg">
            <Package className="w-4 h-4" />
          </div>
          <div>
            <p className="text-xl font-bold text-gray-900">{usedArea.toFixed(3)} m²</p>
            <p className="text-xs text-gray-500">Área Utilizada</p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <div className="p-2 bg-red-50 text-red-600 rounded-lg">
            <Trash2 className="w-4 h-4" />
          </div>
          <div>
            <p className="text-xl font-bold text-gray-900">{wasteArea.toFixed(3)} m²</p>
            <p className="text-xs text-gray-500">Desperdício</p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <div className={`p-2 rounded-lg ${
            parseFloat(efficiency) >= 70 ? 'bg-emerald-50 text-emerald-600' :
            parseFloat(efficiency) >= 50 ? 'bg-amber-50 text-amber-600' :
            'bg-red-50 text-red-600'
          }`}>
            <Percent className="w-4 h-4" />
          </div>
          <div>
            <p className="text-xl font-bold text-gray-900">{efficiency}%</p>
            <p className="text-xs text-gray-500">Aproveitamento</p>
          </div>
        </div>
      </div>

      <div className="mt-4 pt-4 border-t border-gray-200">
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center gap-4">
            <span className="text-gray-600">
              <span className="font-medium">{totalParts}</span> peça(s)
            </span>
            <span className="text-amber-600">
              <span className="font-medium">{pendingCuts}</span> pendientes
            </span>
            <span className="text-emerald-600">
              <span className="font-medium">{completedCuts}</span> cortadas
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoardMetricsCard;
